import I18nForLwText from './LwText'

export default class I18nForLwNumber extends I18nForLwText {
  name = 'lw-number'
}
